module.exports = function(options) {

    return {
        ...options,

        // Overwrite options
        language: 'en',

        // Add styles
        stylesSet: [
            { name: 'Normal', element: 'span', attributes: { 'class': '' } },
            { name: 'Primary button', element: 'a', attributes: { 'class': 'btn-galaxy-primary' } },
        ],

        extraAllowedContent: 'iframe[*]; p a h1 h2 h3 h4 h5(*)',

        format_tags: 'p;h1;h2;h3;h4;h5',

    };

};
